import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { CUSTOM_MASK } from '@helpers/custom-validator';
import { BillsRepository } from '@data-layer/repositories';
import { CompaniesService } from '@services/companies.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { BillItemPendingModel, PaymentMethodModel } from '@data-layer/models/payments';
import { CompanyModel } from '@data-layer/models/companies';
import { Observable, of, ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-card-apply-coupon',
  templateUrl: './card-apply-coupon.component.html',
  styleUrls: ['./card-apply-coupon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardApplyCouponComponent implements OnInit, OnDestroy {
  @Input() public isDesktop: boolean;
  @Input() public isFreight: boolean;
  @Input() public isManualCouponSetting: boolean;
  @Input() public isCouponAvailable: boolean;
  @Input() public referenceNumbers: string[] = [];
  @Input() public selectedPaymentMethod: PaymentMethodModel;
  @Output() public apply: EventEmitter<string> = new EventEmitter<string>();

  public isCouponAvailable$: Observable<boolean>;

  public couponControl: UntypedFormControl;
  public CUSTOM_MASK = CUSTOM_MASK;
  public errors = {
    DISCOUNT_IS_NOT_ACTIVE: 'FORM_ERROR.DISCOUNT_IS_NOT_ACTIVE',
    DISCOUNT_IS_NOT_AUTHORISED: 'KNOWN_ERRORS.DISCOUNT_UNAUTHORIZED_COMPANY',
    DISCOUNT_IS_NOT_FOUND: 'FORM_ERROR.DISCOUNT_IS_NOT_FOUND',
    DISCOUNT_CANNOT_BE_APPLIED: 'FORM_ERROR.DISCOUNT_CANNOT_BE_APPLIED',
  };
  private destroySource$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private cdr: ChangeDetectorRef, private companiesService: CompaniesService, private billsRepository: BillsRepository) {}

  public ngOnInit(): void {
    const company: CompanyModel = this.companiesService.getCompany();

    if (this.isManualCouponSetting) {
      this.isCouponAvailable$ = of(this.isCouponAvailable);
    } else {
      this.isCouponAvailable$ = this.billsRepository
        .pendingBills(company.id, {
          referenceNumbers: this.referenceNumbers,
          paymentProvider: this.selectedPaymentMethod?.provider,
          paymentCodeId: this.selectedPaymentMethod?.codeId,
          paymentMethodId: this.selectedPaymentMethod?.id,
        })
        .pipe(
          takeUntil(this.destroySource$),
          switchMap((bills: BillItemPendingModel[]) => {
            const productCodes: string[] = bills.map((billItem: BillItemPendingModel) => billItem.productCode);
            return this.companiesService.isCouponsAvailable(company.id, productCodes);
          }),
        );
    }

    this.couponControl = new UntypedFormControl(null);
  }

  public ngOnDestroy(): void {
    this.destroySource$.next();
  }

  public setCouponError(errorMessage: string): void {
    this.couponControl.setErrors({ [errorMessage]: true });
    this.cdr.markForCheck();
  }
}
